import { Component, OnDestroy, OnInit } from "@angular/core";
import { sweetAlert } from "../../../utils/swal";
import { ActivatedRoute } from "@angular/router";
import * as _ from 'underscore';
import { exportToCsv } from '../../../utils/utils.common';
import {
  getCompanyLogo,
  weekDays,
} from "../../../utils/utils.common";
import { FleetService } from "../../fleet/fleet-service/fleet.service";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { DriversService } from "../drivers-service/drivers-service";
import { downloadFile } from "src/app/utils/pdf-downloader";
import { urls } from "src/app/utils/url-utils";
import { animate, style, transition, trigger } from "@angular/animations";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { LevelOfServiceService } from "../../level-of-service/service/level-of-service.service";
import { ServiceAreasService } from "../../service-areas/service-areas-service/service-areas.service";
import { EquipmentService } from "../../equipments/equipment-service/equipment.service";
import { forkJoin } from "rxjs";
import { StaffService } from "../../staffs/staff-service/staff.service";
import { CorporateService } from "../../corporate-user/corporate-service/corporate-service";

@Component({
  selector: "app-driver-list",
  templateUrl: "./driver-list.component.html",
  styleUrls: ["./driver-list.component.css"],
  animations: [
    trigger("fleetAssignModalAnimation", [

      transition(":enter", [
        style({ opacity: 0, transform: "translateX(100%)" }),
        animate(
          "750ms ease-in-out",
          style({ opacity: 1, transform: "translateX(0)" })
        )
      ]),

      transition(":leave", [
        style({ opacity: 1, transform: "translateX(0)" }),
        animate(
          "750ms ease-in-out",
          style({ opacity: 0, transform: "translateX(-100%)" })
        )
      ])

    ])
  ]
})
export class DriverListComponent implements OnInit, OnDestroy {
  driverList: any = [];
  search;
  selectedDriver: any;
  path = "";
  user;
  drivers: void[];
  selectedStatus: any = "active";
  driverDetailProfileModal;
  isTimelineSubmitted = false;
  timeZone;
  shift;
  driverManifestModal;
  updatedData;
  preLevelOfServices: any = {};
  showSlideFilter = false;
  shiftAlign = '';
  preServiceAreas: any = {};
  preEquipmentList = {};
  preSpaceTypes: any = {};
  preCorporateUsers: any = {};
  serviceAreasList = [];
  competencyList = [];
  proficiencyList = [];
  selectedProficiencies = [];
  selectedCompetencies = [];
  selectedServiceAreas = [];
  filterDriverList = [];
  fleetsListModal = false;
  fleetData;
  days = weekDays;
  staffList = [];
  selectedStaff = [];
  preStaffList: any = {};
  todayDate;
  preShiftOverrides = {};
  selectedDropdownIndex = -1;
  toggleActionButtons = false;

  constructor(
    private equipmentService: EquipmentService,
    private serviceArea: ServiceAreasService,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private actvatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private levelOfServiceService: LevelOfServiceService,
    private staffService: StaffService,
    private corporateService: CorporateService,
  ) { }

  ngOnInit() {
    this.makeCompulsoryCalls();
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypeList(),
      this.getServiceAreas(),
      this.getEquipmentList(),
      this.getStaffList(),
      this.getCorporateUsers()
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1, res2, res3, res4, res5, res6]) => {

        if (res1) {
          this.preLevelOfServices = res1.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        if (res2) {
          this.preSpaceTypes = res2.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        if (res3) {
          this.preServiceAreas = res3.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        if (res4) {
          this.preEquipmentList = res4.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        if (res5) {
          this.preStaffList = res5.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        if (res6) {
          this.preCorporateUsers = res6.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        this.getUser();
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }


  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          this.timeZone = this.user.timeZone;
          this.timeZone = this.user.timeZone;
          this.todayDate = [
            moment().tz(this.timeZone).startOf('day').toISOString(),
            moment().tz(this.timeZone).endOf('day').toISOString()
          ];
          this.getDriverList();
        }
      });
  }

  getDriverList() {
    this.serviceAreasList = [];
    this.competencyList = [];
    this.proficiencyList = [];
    this.staffList = [];

    this.selectedProficiencies = [];
    this.selectedCompetencies = [];
    this.selectedServiceAreas = [];
    this.selectedStaff = [];

    this.driverService.getDrivers(this.user._id, this.selectedStatus)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.driverList = data;
            this.filterDriverList = this.driverList;

            for (let driver of this.driverList) {
              if (driver.serviceAreas && driver.serviceAreas.length) {
                for (let area of driver.serviceAreas) {
                  if (area && this.preServiceAreas[area])
                    this.serviceAreasList.push(this.preServiceAreas[area]);
                }
              }

              if (driver.proficiency && driver.proficiency.length) {
                for (let proficiency of driver.proficiency) {
                  if (proficiency && this.preSpaceTypes[proficiency])
                    this.proficiencyList.push(this.preSpaceTypes[proficiency]);
                }
              }

              if (driver.competency && driver.competency.length) {
                for (let competency of driver.competency) {
                  if (competency && this.preEquipmentList[competency])
                    this.competencyList.push(this.preEquipmentList[competency]);
                }
              }
              if (driver.stationManager) {
                this.staffList.push(this.preStaffList[driver.stationManager]);
              }
            }

            this.serviceAreasList = _.uniq(this.serviceAreasList, '_id').sort();
            this.proficiencyList = _.uniq(this.proficiencyList, '_id').sort();
            this.competencyList = _.uniq(this.competencyList, '_id').sort();
            this.staffList = _.uniq(this.staffList, '_id').sort();
            this.getShiftOverrides();
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  getLevelOfService() {

    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypeList() {

    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  getServiceAreas() {
    return this.serviceArea.getServiceAreas({ status: 'active' });
  }

  getCorporateUsers() {
    return this.corporateService.getCorporateUsers('active');
  }

  getEquipmentList() {
    let queryParams = {
      isAddon: false,
      status: 'active'
    }
    return this.equipmentService.getEquipments(queryParams);
  }

  getStaffList() {
    let queryParams = {
      status: 'active'
    }
    return this.staffService.getStaffList(queryParams);
  }

  onChangeStatus() {
    this.getDriverList();
  }

  onClickProfile(driver) {
    this.driverDetailProfileModal = driver;
  }

  currentSelectedFleet(driver) {
    this.fleetsListModal = true;
    this.selectedDriver = driver;

  }

  generateQRCode(driver) {
    this.driverService.generateDriverQR(driver._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data && data.pdfName) {
          const name = data.pdfName;
          const url = urls.SERVER_URL + "pdf/" + name;
          downloadFile(url, "", name);
        }
      });
  }

  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  filterDrivers() {
    this.filterDriverList = this.driverList.filter(driver => {

      let isServiceAreasExist = true;
      let isCompetencyExist = true;
      let isProficiencyExist = true;
      let isShiftAlign = true;
      let isStaffExist = true;

      if (driver.serviceAreas && this.selectedServiceAreas && this.selectedServiceAreas.length) {
        for (let item of this.selectedServiceAreas) {
          const isIncluded = driver.serviceAreas.includes(item)
          if (isIncluded) {
            isServiceAreasExist = true;
          } else {
            isServiceAreasExist = false;
            break;
          }
        }
      }

      if (driver.competency && this.selectedCompetencies && this.selectedCompetencies.length) {
        for (let item of this.selectedCompetencies) {
          const isIncluded = driver.competency.includes(item)
          if (isIncluded) {
            isServiceAreasExist = true;
          } else {
            isServiceAreasExist = false;
            break;
          }
        }
      }

      if (driver.proficiency && this.selectedProficiencies && this.selectedProficiencies.length) {
        for (let item of this.selectedProficiencies) {
          const isIncluded = driver.proficiency.includes(item)
          if (isIncluded) {
            isProficiencyExist = true;
          } else {
            isProficiencyExist = false;
            break;
          }
        }
      }

      if (driver.shiftAlign && this.shiftAlign) {
        isShiftAlign = driver.shiftAlign === this.shiftAlign;
      }
      if (driver.stationManager && this.selectedStaff && this.selectedStaff.length) {
        const isExist = this.selectedStaff.find(sId => sId === driver.stationManager);

        if (isExist) {
          isStaffExist = true;
        } else {
          isStaffExist = false;
        }
      }
      if (isServiceAreasExist && isCompetencyExist && isProficiencyExist && isShiftAlign && isStaffExist) {
        return true;
      } else {
        return false;
      }
    }
    );

  }

  updateVehicle(event?) {
    if (event) {
      this.selectedDriver.isFleet = event.isFleet;
      this.selectedDriver.fleet = event.fleet;
    }
  }

  currentDayShift(shifts) {
    const currentDay = moment().tz(this.timeZone).day();
    if (shifts) {
      let shift = shifts.find(shift => shift.day === currentDay);
      return shift;
    } else {
      return {};
    }
  }

  getShiftOverrides() {
    const payload = {
      startDate: moment(this.todayDate[0]).tz(this.timeZone).toISOString(),
      endDate: moment(this.todayDate[1]).tz(this.timeZone).toISOString(),
      status: 'active'
    }
    this.driverService.getShiftOverridesByDate(payload).subscribe(data => {
      this.preShiftOverrides = data.reduce((obj, item) => {
        if (!obj[item.driver._id]) {
          obj[item.driver._id] = [];
        }
        obj[item.driver._id].push(item);
        return obj;
      }, {});
    });

  }

  showActionButtons(idx) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  ngOnDestroy(): void {
  }


  driversCsvReport() {
    const table = [
      [
        "Name",
        "Email",
        "Mobile Number",
        "Address",
        "Employee Id",
        "Rippling Id",
        "License Number",
        "Employment Type",
        "Role/Source",
        "Version",
        "Staff Manager",
        "Cost Center",
        "Shift Align",
        "Vehicle",
        "Competency",
        "Proficiency",
        "Service Area(s)",
        "Funding Source",
        "Status",
        "Shift (Sun)",
        "Shift (Mon)",
        "Shift (Tue)",
        "Shift (Wed)",
        "Shift (Thu)",
        "Shift (Fri)",
        "Shift (Sat)"
      ]
    ];

    this.filterDriverList.forEach((driver: any) => {

      const serviceAreas = (driver.serviceAreas && this.preServiceAreas) ? driver.serviceAreas.map((serviceArea: any) => this.preServiceAreas[serviceArea] ? this.preServiceAreas[serviceArea].name : '').filter(Boolean).join(', ') : '';

      const fundingsource = (driver.fundingSources && this.preCorporateUsers) ? driver.fundingSources.map((fs: any) => this.preCorporateUsers[fs.name] ? this.preCorporateUsers[fs.name].displayName : '').filter(Boolean).join(', ') : '';

      const los = (this.preLevelOfServices && driver.fleet && driver.fleet.los) ? this.preLevelOfServices[driver.fleet.los].title : '';

      const spaceType = (this.preSpaceTypes && driver.fleet && driver.fleet.spaceType) ? this.preSpaceTypes[driver.fleet.spaceType].title : '';

      const vehicle = los && spaceType ? `${los} (${spaceType})` : los || spaceType || '';

      const competencies = (driver.competency && this.preEquipmentList) ? driver.competency.map((competency: any) => this.preEquipmentList[competency] ? this.preEquipmentList[competency].title : '').filter(Boolean).join(', ') : '';

      const proficiency = (driver.proficiency && this.preSpaceTypes) ? driver.proficiency.map((proficiency: any) => this.preSpaceTypes[proficiency] ? this.preSpaceTypes[proficiency].title : '').filter(Boolean).join(', ') : '';

      const shiftColumns = Array(7).fill(' ');

      for (const s of driver.shifts || []) {
        if (s.isEnabled) {
          shiftColumns[s.day] = `${s.checkin}-${s.checkout}`;
        }
      }

      const data = [
        driver.displayName || '',
        driver.email || '',
        driver.contactNumber || '',
        driver.address || '',
        driver.employeeId || '',
        driver.ripplingWorkerId || '',
        driver.driverLicenseNumber || '',
        driver.type || '',
        `${driver.profileRole || ''}/${driver.source || ''}`,
        driver.buildVersion || 'N/A',
        this.preStaffList && this.preStaffList[driver.stationManager] ? this.preStaffList[driver.stationManager].displayName : '',
        driver.costCenter || '',
        driver.shiftAlign || '',
        vehicle,
        competencies,
        proficiency,
        serviceAreas,
        fundingsource,
        driver.accountStatus || '',
        ...shiftColumns
      ];

      table.push(data);
    });

    exportToCsv(`Drivers_Report.csv`, table);
  }

  showDriverManifest(driver) {
    this.driverManifestModal = driver._id;
  }
}
